export default __webpack_public_path__ + "static/media/placement_surge.67b1f0d0.pdf";